import styled from 'styled-components';
import { ColorHealth5 } from 'autogen/design-tokens/tokens';
import type { BasketMessageSameDayDeliveryViewModel } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';
import WithIcon from 'components/hoc/withIcon/WithIcon';
import Icon from 'components/Icon';
import format from 'helpers/translations';
import BasketMessageContainer from '../shared/styles';

const StyledBasketMessageContainer = styled(BasketMessageContainer)`
    background-color: ${ColorHealth5};
`;

export default function SameDayDeliveryMessage({ model: { text } }: { model: BasketMessageSameDayDeliveryViewModel }) {
    return (
        <StyledBasketMessageContainer>
            <WithIcon icon={<Icon type="Clock" size={16} />}>
                <Typography.Body as="span" size="S">
                    {format(text)}
                </Typography.Body>
            </WithIcon>
        </StyledBasketMessageContainer>
    );
}
